import flexeApi from '../lib/flexeApi';
import { SlaMetric, SlaMetricSubtype } from '../CommonInterfaces';

export class ReservationSlaMetricsService {
  public retrieveSlaMetrics(reservationId: number) {
    return flexeApi
      .getReservationSlaMetrics(reservationId)
      .then((response: any) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return { error: response.status };
        }
      })
      .then((response) => {
        if (response !== undefined && !response.error) {
          // Data arrives in a flat list with possibly multiple metrics with the same name but different subtypes
          // and values. Reorganize into a hierarchy so we can assign multiple subtypes to the same metric name.
          const organizedResponse = {};
          response.data.metrics.forEach((data) => {
            // Make sure we use the enum values, not strings.
            const slaMetric = data.metric as SlaMetric;
            const slaSubtype = data.metric_subtype as SlaMetricSubtype;
            organizedResponse[slaMetric] ||= {};
            organizedResponse[slaMetric][slaSubtype] = data.value;
          });

          // Data may not be present for all possible metrics. Fill in the gaps with empty values so the user can
          // create what's missing if they wish.
          const metrics = {};
          Object.values(SlaMetric).forEach((metric) => {
            metrics[metric] = organizedResponse[metric] || {};
            Object.values(SlaMetricSubtype).forEach((subtype) => {
              metrics[metric][subtype] ||= null; // this ensures the key is present
            });
          });

          return metrics;
        } else {
          return null;
        }
      });
  }
}
